<template>
  <div class="flex items-center" v-if="visible">
    <div class="mr-3">Địa chỉ</div>
    <div class="flex rounded-md border border-gray-300 overflow-hidden">
      <a
        href="javascript:;"
        class="px-3 py-1"
        :class="mode === 'old' ? 'bg-theme-1 text-white' : 'text-gray-700'"
        @click="setMode('old')"
      >
        Cũ (3 cấp)
      </a>
      <a
        href="javascript:;"
        class="px-3 py-1 border-l border-gray-300"
        :class="mode === 'new' ? 'bg-theme-1 text-white' : 'text-gray-700'"
        @click="setMode('new')"
      >
        Mới (2 cấp)
      </a>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent } from "vue";
import { useStore } from "@/store";
import { authService } from "@/services";
import { AddressMode } from "@/libs/address";

export default defineComponent({
  name: "AddressModeToggle",
  setup() {
    const store = useStore();
    const mode = computed(() => store.state.main.addressMode);
    // Danh mục 2 cấp mới chỉ áp dụng cho J&T, BEST vẫn dùng danh mục GHTK
    const visible = authService.getUserInfoLocal()?.shippingCode !== "BEST";

    const setMode = (value: AddressMode) => {
      store.commit("main/SET_ADDRESS_MODE", value);
    };

    return { mode, visible, setMode };
  },
});
</script>
